import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Body, Footer, Popup } from '@calendly/ui/components/popup'
import { Button } from '@calendly/ui/components/button'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { HtmlParser } from '@calendly/html-parser'
import { Link } from '@calendly/ui/components/link'
import { BodyText } from '@calendly/ui/components/typography'

import { useI18n } from 'locales'
import { calendarAccountsLoadedSelector, calendarAccountsSelector } from 'selectors'
import { fetchAccounts } from 'actions/calendar_accounts'
import { currentUserSelector } from 'selectors/user'

import Account from './account'
import { AccountLoader, Wrapper } from './styles'

const CalendarConnectionsLink = ({ children }) => {
  const url = '/app/availability/connected_calendars'

  return <Link href={url} target="_blank" rel="opener">{children}</Link>
}

const MutualAvailabilityPopup = ({ onClose }) => {
  const { i18n } = useI18n()
  const { locale } = useSelector(currentUserSelector)
  const loaded = useSelector(calendarAccountsLoadedSelector)
  const accounts = useSelector(calendarAccountsSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    if (!loaded) {
      dispatch(fetchAccounts())
    }
  }, [dispatch, loaded])

  return (
    <Popup isOpen onClose={onClose} title={i18n.t('publisher.mutual_availability.popup.title', { locale })}>
      <Body>
        <Wrapper>
          <BodyText>{i18n.t('publisher.mutual_availability.popup.body', { locale })}</BodyText>
          {
            loaded
              ? accounts.map(({
                id, email, pull_calendars: pullCalendars, kind
              }) => <Account key={id} email={email} pullCalendars={pullCalendars} kind={kind} />)
              : <AccountLoader />
          }
          <ContextualBanner variant="subtle">
            <BodyText weight="bold" inline size="medium">{i18n.t('publisher.mutual_availability.popup.note', { locale })}</BodyText>
            {' '}
            <BodyText inline size="medium">
              {
                HtmlParser(
                  i18n.t('publisher.mutual_availability.popup.note_full', { locale }),
                  { CalendarConnectionsLink }
                )
              }
            </BodyText>
          </ContextualBanner>
        </Wrapper>
      </Body>

      <Footer>
        <Button onClick={onClose}>{i18n.t('publisher.mutual_availability.popup.submit', { locale })}</Button>
      </Footer>
    </Popup>
  )
}

export default MutualAvailabilityPopup
